import cx from "classnames";
import type { ICDUpdateData } from "components/ICDCoding/icdAdapter";
import { lienToIcdObject } from "components/ICDCoding/icdAdapter";
import ICDCodingBlock from "components/ICDCoding/ICDCodingBlock";
import type { FC } from "react";
import { memo, useCallback } from "react";
import {
  useGetLienByIdQuery,
  usePatchLienByIdMutation,
} from "services/lien-api";
import { useSelector } from "utils/redux";

type Props = {
  lienId: string;
};

export const LienICDCodingDrawer: FC<Props> = memo(({ lienId }) => {
  const showLienICDCodingDrawer = useSelector(
    (state) => state.drawer.showLienICDCodingDrawer,
  );

  const { data: lien, isLoading } = useGetLienByIdQuery(
    { lienId },
    { skip: !lienId },
  );

  const [patchLien] = usePatchLienByIdMutation();

  const handleSaveIcdData = useCallback(
    async (data: ICDUpdateData) => {
      if (!lienId) return;
      await patchLien({ lienId, data }).unwrap();
    },
    [lienId, patchLien],
  );

  return (
    <div
      className={cx("documents notes-msa flex jc-se", {
        open: showLienICDCodingDrawer,
      })}
    >
      <div className="documents-wrapper notes">
        <div className="swim-wrapper h-100">
          <div className="grid-layout gl-1 no-gap-tb swimlanes">
            <div className="swim-headers">ICD Coding</div>
            <div className="swim-column">
              <ICDCodingBlock
                data={lien ? lienToIcdObject(lien) : undefined}
                isLoading={isLoading}
                onSave={handleSaveIcdData}
                showAcceptanceButtons={true}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

LienICDCodingDrawer.displayName = "LienICDCodingDrawer";
